import { SubscriptionSchema } from "@pollyslack/hub/src/features";
import { EnterpriseGrid } from "@pollyslack/hub/src/types";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { BoolCheck } from "../../../components/BoolCheck";
import { Date } from "../../../components/Date";
import { DocumentTable } from "../../../components/DocumentTable";
import { getEnterpriseSubscriptions } from "../../../services/api/Organization";
import { GridLink } from "../../../components/DocumentLink";
import NoDataMessage from "../../../common/NoDataMessage";

type EnterpriseTableProps = {
  grids: EnterpriseGrid[];
};
export const EnterpriseTable: React.FunctionComponent<EnterpriseTableProps> = (
  props: EnterpriseTableProps,
) => {
  const [enterpriseSubs, setEnterpriseSubs] = useState<SubscriptionSchema[]>(
    [],
  );
  useEffect(() => {
    const slackEnterpriseIds = _.uniq(
      props.grids.map((grid) => grid.slackEnterpriseId).filter((id) => !!id),
    );
    getEnterpriseSubscriptions({ slackEnterpriseIds })
      .then((subs) => {
        setEnterpriseSubs(subs);
      })
      .catch(() => setEnterpriseSubs([]));
  }, [props.grids]);

  const properties = [
    {
      title: "Slack Enterprise ID",
      render: (d: EnterpriseGrid) => <GridLink docId={d.slackEnterpriseId} />,
    },
    {
      title: "Enterprise Name",
      render: (d: EnterpriseGrid) => d.slackEnterpriseName,
    },
    {
      title: "Bot User ID",
      render: (d: EnterpriseGrid) => d.slackBotUserId,
    },
    {
      title: "Bot Name",
      render: (d: EnterpriseGrid) => d.slackBotName || "—",
    },
    {
      title: "Plan",
      render: (d: EnterpriseGrid) => {
        const sub = enterpriseSubs.find(
          (sub) => sub.slackEnterpriseId === d.slackEnterpriseId,
        );
        return sub?.tier || "—";
      },
    },
    {
      title: "Created",
      render: (d: EnterpriseGrid) => <Date date={d.createdAt} />,
    },
    {
      title: "Active",
      render: (d: EnterpriseGrid) => (
        <BoolCheck check={d.slackBotTokenActive} />
      ),
    },
    {
      title: "Marketing Opt-In",
      render: (d: EnterpriseGrid) => (
        <BoolCheck check={d.settings?.optIns?.marketing ?? false} />
      ),
    },
  ];

  if (!props.grids || props.grids.length === 0) {
    return <NoDataMessage componentName="enterprise grid" />;
  }

  return (
    <DocumentTable<EnterpriseGrid>
      properties={properties}
      objects={props.grids}
    />
  );
};
